import React, { useMemo } from "react";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { FormattedMessage } from "react-intl";
import logo from "./../../../../app/assets/images/Active-citizens-fund.png";

const FooterLikumi = () => {
  const today = new Date().getFullYear();
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      footerClasses: uiService.getClasses("footer", true),
      footerContainerClasses: uiService.getClasses("footer_container", true),
    };
  }, [uiService]);

  return (
    <div
      className={`footer bg-white py-4 d-flex flex-lg-column  ${layoutProps.footerClasses}`}
      id="kt_footer"
    >
      <div
        className={`${layoutProps.footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}
      >
        <div className="text-dark order-2 order-md-1">
          <span className="text-muted font-weight-bold mr-2">
            {today.toString()}
          </span>{" "}
          &copy;{" "}
          <a
            href="https://manabalss.lv"
            target="_blank"
            rel="noopener noreferrer"
            className="text-dark-75 text-hover-primary"
          >
            ManaBalss.lv
          </a>
        </div>

        <div className="text-dark order-2 order-md-2" style={{textAlign: 'center'}}>
          <img alt="Logo" className="max-h-50px" src={logo} />
          <p style={{fontSize: 10, paddingTop: 10}}>
            <FormattedMessage id="FOOTER.GRANT" />
          </p>
        </div>

        <div className="nav nav-dark order-1 order-md-3">
          <a
            href={"https://open2vote.eu/pages/opensaeima"}
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link pr-3 pl-0"
          >
            <FormattedMessage id="FOOTER.LINK_1" />
          </a>
          <a
            href={"https://myvoice.group/kontakti/"}
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link pl-3 pr-0"
          >
            <FormattedMessage id="FOOTER.LINK_2" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default FooterLikumi;
